import { toast } from 'react-toastify'

export const getCoin = (currency = 'USDT', tokens) => {
  return tokens?.tokens.find((x) => x.crypto === currency)
}

const getOnRampCrypto = (network, currency) => {
  const NETWORK_MAP = {
    USDT: {
      ARETH: 'usdt_arbitrum',
      BSC: 'usdt_bsc',
      POLYGON: 'usdt_polygon',
      SOL: 'usdt_solana',
      ETH: 'usdt_ethereum',
      OPTIMISM: 'usdt_optimism',
      TRX: 'usdt_tron',
      TON: 'usdt_ton',
    },
    ETH: {
      ARETH: 'eth_arbitrum',
      ETH: 'eth_base',
      BSC: 'eth_bsc',
      OPTIMISM: 'eth_optimism',
      LINEA: 'eth_linea',
    },
    BTC: 'btc',
    LTC: 'ltc_litecoin',
  }

  return NETWORK_MAP[currency][network]
}

export const getUrl = ({ network, currency }): string => {
  const KEY = import.meta.env.VITE_ONRAMPER_API_KEY
  const MODE = 'buy'
  const SUCCESS_URL = 'https://blackjack.fun/?buy=success_redirect'
  const ERROR_URL = 'https://blackjack.fun/?buy=error_redirect'
  const URL = 'https://buy.onramper.dev'
  const crypto_network = getOnRampCrypto(network, currency)

  return `${URL}?apiKey=${KEY}&mode=${MODE}&onlyCryptos=${crypto_network}&successRedirectUrl=${SUCCESS_URL}&errorRedirectUrl=${ERROR_URL}`
}

export const getOnRampToast = (t) => {
  const params = new URLSearchParams(location.search)
  const buyStatus = params.get('buy')

  const clean = () => {
    // Clean up parameter from URL
    const cleanUrl = window.location.pathname
    window.history.replaceState({}, '', cleanUrl)
  }

  if (buyStatus === 'success_redirect') {
    toast.success(t('wallet.onramp.purchaseSuccess', 'Your cryptocurrency purchase was successful'))

    clean()
  }

  if (buyStatus === 'error_redirect') {
    toast.error(t('wallet.onramp.purchaseFailed', 'Your cryptocurrency purchase failed'))
    clean()
  }
}
